'use client';

import type { BankDetails } from '@/api/entities';
import { deleteBankPayment, deleteUpiPayment } from '@/api/user';
import { isActionError } from '@/lib/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
export type PaymentMethods = {
  bank?: BankDetails;
  upi?: string;
} | undefined;
export function useDeletePaymentMethod() {
  const queryClient = useQueryClient();
  const deleteBankMutation = useMutation({
    mutationFn: async () => {
      const response = await deleteBankPayment();
      if (isActionError(response)) {
        throw response.error;
      }
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['paymentMethods']
      });
    }
  });
  const deleteUpiMutation = useMutation({
    mutationFn: async () => {
      const response = await deleteUpiPayment();
      if (isActionError(response)) {
        throw response.error;
      }
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['paymentMethods']
      });
    }
  });
  const handleDelete = async (type: 'bank' | 'upi') => {
    try {
      if (type === 'bank') {
        await deleteBankMutation.mutateAsync();
      } else {
        await deleteUpiMutation.mutateAsync();
      }
    } catch (error) {
      console.error('Failed to delete payment method:', error);
      throw error;
    }
  };
  return {
    handleDelete,
    isDeleting: deleteBankMutation.isPending || deleteUpiMutation.isPending,
    error: deleteBankMutation.error || deleteUpiMutation.error
  };
}